import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import {
    DataGridPro,
} from '@mui/x-data-grid-pro';
import {
    Stack,
    Typography,
    IconButton,
    ToggleButton,
    ToggleButtonGroup,
    Box,
    Chip,
    Paper,
    Button,
    Pagination,
} from '@mui/material';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

import CircularProgress from "@material-ui/core/CircularProgress";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PaymentIcon from '@mui/icons-material/Payment';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import axios from '../../../../axios-order';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import excelIconImage from '../../../../asserts/images/excelicon.svg'



export default function TdsLiabilities() {
    let history = useHistory();
    const [view, setView] = useState('list');
    const [statusView, setStatusView] = useState(localStorage.getItem('tdsLiabilityStatusView') || 'unpaid');
    const [tdsLiabilitiesData, setTdsLiabilitiesData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [quarter, setQuarter] = useState(localStorage.getItem('quarter_26Q') || 'Q1');
    const [loading, setLoading] = useState(false);
    const [sitemapData, setSitemapData] = useState(null);
    const [isExporting, setIsExporting] = useState(false);
    const [isQuarterFullyAssociated, setIsQuarterFullyAssociated] = useState(false)

    const listPageSize = 3;
    const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    const CustomToolbarPrimary = ({ statusView, onChangeStatusView }) => (
        <ToggleButtonGroup
            size="small"
            value={statusView}
            exclusive
            onChange={(_, newView) => {
                if (newView) {
                    onChangeStatusView(newView);
                    localStorage.setItem('tdsLiabilityStatusView', newView);
                }
            }}
        >
            <ToggleButton
                value="unpaid"
                sx={{
                    gap: 0.5,
                    '&.Mui-selected': {
                        bgcolor: 'primary.main',
                        color: 'common.white',
                        '&:hover': { bgcolor: 'primary.dark' },
                    },
                }}
            >
                <PaymentIcon fontSize="small" />
                <Typography variant="caption">UnPaid</Typography>
            </ToggleButton>
            <ToggleButton
                value="paid"
                sx={{
                    gap: 0.5,
                    '&.Mui-selected': {
                        bgcolor: 'primary.main',
                        color: 'common.white',
                        '&:hover': { bgcolor: 'primary.dark' },
                    },
                }}
            >
                <CreditScoreIcon fontSize="small" />
                <Typography variant="caption">Paid</Typography>
            </ToggleButton>
        </ToggleButtonGroup>
    );


    const formatCurrency = (value) => {
        if (!value || value == null || value === '') return '₹0';
        return `₹${value.toLocaleString('en-IN')}`;
    };

    const handleViewTDSPayableDashboardData = (item) => {
        history.push({
            pathname: `/TdsPayableDashboard`,
            state: { items: item }
        })
    }

    const handleFom26QFiling = () => {
        history.push({
            pathname: `/26QFormFiling`
        })
    }

    const TdsListCard = ({ item }) => (
        <Paper
            elevation={2}
            sx={{
                p: 2,
                mb: 2,
                borderRadius: 2,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                display: 'flex',
                justifyContent: 'space-between',
                borderLeft: statusView === "paid" ? '2px solid #00e676' : '2px solid #ff1744',
                alignItems: 'center',
                backgroundColor: '#fff',
                boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
                transition: '0.3s ease',
                '&:hover': {
                    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
                    backgroundColor: '#f9f9f9',
                },
            }}
        >
            {/* Left Section */}
            <Box sx={{ flex: 1 }}>
                <Stack direction="row" spacing={2} alignItems="center" mb={3} mt={1}>
                    <Typography variant="subtitle1" fontWeight={520}>
                        {item.perticulars}
                    </Typography>
                    {item.over_due_days > 0 && (
                        <Chip
                            label={`OVERDUE BY ${item.over_due_days} DAYS`}
                            icon={<WarningAmberIcon fontSize="small" />}
                            size="small"
                            sx={{
                                backgroundColor: '#fdecea',
                                color: '#c62828',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                borderRadius: 0,
                                height: 24,
                            }}
                        />
                    )}
                </Stack>

                <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap" mb={1}>
                    {[
                        { label: 'TOTAL TDS', value: formatCurrency(item.tds_amount) },
                        { label: 'PERIOD', value: item.period },
                        { label: 'DUE', value: item.due_date },
                        { label: 'INTEREST', value: formatCurrency(item.interest) },
                        { label: 'PENALTY', value: formatCurrency(item.penalty) },
                        ...(statusView !== "paid" ? [{ label: 'Associated Amount', value: formatCurrency(item.associated_amount) }] : []),
                    ].map(({ label, value }) => (
                        <Box
                            key={label}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                px: 1.5,
                                py: 0.5,
                                backgroundColor: '#f5f5f5',
                                borderRadius: 1,
                                fontSize: '0.85rem',
                                fontWeight: 500,
                                textTransform: 'uppercase',
                                color: '#333',
                            }}
                        >
                            <Typography
                                variant="caption"
                                sx={{ fontWeight: 600, color: 'text.secondary' }}
                            >
                                {label}:
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                {value}
                            </Typography>
                        </Box>
                    ))}
                    {item.over_due_days === 0 && (
                        <Chip
                            label={statusView === "paid" ? 'Fully Associated' : 'On Time'}
                            // color="success"
                            size="small"
                            sx={{
                                fontWeight: 600,
                                backgroundColor: '#00e676',
                                textTransform: 'uppercase',
                                borderRadius: 1,
                                height: 26,
                                alignSelf: 'center',
                                ml: 1,
                            }}
                        />
                    )}
                </Stack>


            </Box>



            {/* Right Section - Actions */}
            <Stack direction="row" spacing={2} sx={{ ml: 2 }}>

                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    endIcon={<VisibilityIcon />}
                    onClick={() => handleViewTDSPayableDashboardData(item)}
                    sx={{ textTransform: 'none', fontWeight: 500 }}
                >
                    View Details
                </Button>
            </Stack>
        </Paper>
    );

    const getTdsLiabilitiesData = () => {
        setLoading(true);
        const payLoadData = {
            financial_year: localStorage.getItem('financial_year_26Q'),
            business_entity_id: localStorage.getItem('business_entity_id'),
            quarter: quarter,
            is_paid: statusView === "paid"
        };
        axios
            .post('/payable_table2', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    setTdsLiabilitiesData(res?.data?.records);
                    setIsQuarterFullyAssociated(res?.data?.is_quarter_fully_paid)
                }
            })
            .catch((err) => console.error('Error fetching TDS liabilities:', err))
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getTdsLiabilitiesData()
    }, [statusView, quarter]);

    const paginatedData = tdsLiabilitiesData.slice(
        (page - 1) * listPageSize,
        page * listPageSize
    );

    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = () => {
        const financial_year = localStorage.getItem('financial_year_26Q')
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `TDS Payable Reconciliation Report-${financial_year} ${quarter}.xlsx`;

        setIsExporting(true);

        axios
            .post(`/get_payable_challan_recon_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: financial_year,
                quarter: quarter
            })
            .then((res) => {
                downloadBase64File(contentType, res.data.file, filename);
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setIsExporting(false);
            })
    }


    console.log('activate filing button........', purchaseAccess.includes("26Q FILLING"), statusView === "paid", isQuarterFullyAssociated)

    return (
        <Box sx={{ width: '99%', mx: 'auto', mt: 1 }}>

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: 2,
                    py: 1,
                    flexWrap: 'wrap',
                }}
            >
                {/* Left: Paid/Unpaid Toggle */}
                <CustomToolbarPrimary
                    statusView={statusView}
                    onChangeStatusView={setStatusView}
                />

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: 1,
                    }}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>

                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                // color: 'primary.main',
                                letterSpacing: 1,
                                textTransform: 'uppercase',
                            }}
                        >
                            TDS Liabilities ({localStorage.getItem('financial_year_26Q')} {localStorage.getItem('quarter_26Q')})
                        </Typography>
                    </Stack>
                </Box>

                {/* Right: List/Grid Toggle */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Stack direction="row" spacing={2} alignItems="center">


                        <FormControl
                            size="small"
                            sx={{
                                minWidth: 140,
                                fontWeight: 500,
                                '.MuiInputBase-root': {
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    height: '40px',
                                    backgroundColor: '#E3F2FD', // light blue
                                    color: '#0D47A1', // dark blue text
                                    fontWeight: 600,
                                },
                                '.MuiInputLabel-root': {
                                    fontSize: '14px',
                                },
                            }}
                        >
                            <InputLabel id="quarter-select-label">Quarter</InputLabel>
                            <Select
                                labelId="quarter-select-label"
                                id="quarter-select"
                                value={quarter}
                                label="Quarter"
                                onChange={(e) => {
                                    setQuarter(e.target.value);
                                    localStorage.setItem('quarter_26Q', e.target.value);
                                }}
                            >
                                {['Q1', 'Q2', 'Q3', 'Q4'].map((q) => (
                                    <MenuItem key={q} value={q}>
                                        {q}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>


                        <Button
                            variant="outlined"
                            color="success"
                            disabled={isExporting}
                            onClick={handleDownloadReport}
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                marginLeft: 3,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                opacity: isExporting ? 0.85 : 1,
                            }}
                            endIcon={
                                isExporting ? (
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="8" cy="8" r="6"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeDasharray="28"
                                            strokeDashoffset="10"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                ) : (
                                    <img src={excelIconImage} alt="Excel" style={{ width: 20, height: 20 }} />
                                )
                            }
                        >
                            {isExporting ? 'EXPORTING...' : 'Export'}
                        </Button>

                        <Button
                            variant="contained"
                            size="medium"
                            color="primary"
                            startIcon={<ArrowBackIcon />}
                            onClick={() => {
                                localStorage.removeItem('tdsLiabilityStatusView');
                                history.goBack();
                            }}
                            sx={{ textTransform: 'none', fontWeight: 500 }}
                        >
                            Back
                        </Button>

                    </Stack>

                </div>
            </Box>


            {loading ? (
                <Box sx={{ mt: 10, textAlign: 'center' }}>
                    <CircularProgress size={40} thickness={4} />
                    <Typography variant="body2" mt={2}>Loading TDS Liabilities...</Typography>
                </Box>
            ) : tdsLiabilitiesData.length === 0 ? (
                <Box
                    sx={{
                        mt: 10,
                        py: 6,
                        textAlign: 'center',
                        borderRadius: 3,
                        // backgroundColor: '#f5f7fa',
                        // boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                        px: 3,
                        mx: 'auto',
                        maxWidth: 600,
                    }}
                >
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <InboxOutlinedIcon
                            sx={{
                                fontSize: 64,
                                color: 'primary.main',
                                opacity: 0.8,
                            }}
                        />
                    </Box>

                    <Typography variant="h6" fontWeight={600} gutterBottom color="text.secondary">
                        No TDS {statusView.toUpperCase()} Liabilities Available
                    </Typography>

                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        We couldn’t find any TDS liabilities for the selected criteria (Quarter / Status).
                    </Typography>

                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => getTdsLiabilitiesData()}
                        sx={{ textTransform: 'none', borderRadius: 2 }}
                    >
                        Retry Fetching Data
                    </Button>
                </Box>

            ) : (
                <Box sx={{ mt: 1 }}>
                    {tdsLiabilitiesData.map((item) => (
                        <TdsListCard key={item.id} item={item} />
                    ))}
                    {/* {canWrite("PAYABLES") && purchaseAccess.includes("26Q FILLING") && statusView === "paid" && isQuarterFullyAssociated && (
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<DescriptionOutlinedIcon />}
                                onClick={() => handleFom26QFiling()}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: 2,
                                    fontWeight: 600,
                                    '&:hover': {
                                        backgroundColor: '#303f9f',
                                        boxShadow: '0 5px 10px rgba(48, 63, 159, 0.5)',
                                    },
                                }}
                            >
                                TDS Filing
                            </Button>
                    )}
                        </Box>
                    } */}
                </Box>
            )}

        </Box>
    );
}
